// frontend/src/api/livestock.ts

import { api } from './client';
import type {
  Livestock,
  LivestockCreate,
  LivestockUpdate,
  LivestockStatusUpdate,
  LivestockListResponse,
  LivestockSummary,
} from '@/types/livestock';

export const livestockApi = {
  async list(tankId: string, params?: { status?: string; search?: string }): Promise<LivestockListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.append('status', params.status);
    if (params?.search) searchParams.append('search', params.search);

    const query = searchParams.toString();
    const url = `/api/tanks/${tankId}/livestock${query ? `?${query}` : ''}`;
    return api.get<LivestockListResponse>(url);
  },

  async get(tankId: string, livestockId: number): Promise<Livestock> {
    return api.get<Livestock>(`/api/tanks/${tankId}/livestock/${livestockId}`);
  },

  async create(tankId: string, data: LivestockCreate): Promise<Livestock> {
    return api.post<Livestock>(`/api/tanks/${tankId}/livestock`, data);
  },

  async update(tankId: string, livestockId: number, data: LivestockUpdate): Promise<Livestock> {
    return api.put<Livestock>(`/api/tanks/${tankId}/livestock/${livestockId}`, data);
  },

  async updateStatus(tankId: string, livestockId: number, data: LivestockStatusUpdate): Promise<Livestock> {
    return api.put<Livestock>(`/api/tanks/${tankId}/livestock/${livestockId}/status`, data);
  },

  async delete(tankId: string, livestockId: number): Promise<void> {
    return api.delete(`/api/tanks/${tankId}/livestock/${livestockId}`);
  },

  async getSummary(tankId: string): Promise<LivestockSummary> {
    return api.get<LivestockSummary>(`/api/tanks/${tankId}/livestock/summary`);
  },
};
